import { createFileRoute, Navigate } from '@tanstack/react-router'
import { QueryGuard } from '../../components/query-guard'
import { StartupShareContent } from '../../features/startup/components/startup-share-content'
import { useStartupQuery } from '../../hooks/api'
import { useIsFounder } from '../../hooks/use-user-type'

export const Route = createFileRoute('/_protected/share')({
  component: SharePage,
})

function SharePage() {
  const isFounder = useIsFounder()

  if (!isFounder) {
    return <Navigate to="/pitches" />
  }

  return <FounderShare />
}

function FounderShare() {
  const startupQuery = useStartupQuery()

  return (
    <QueryGuard query={startupQuery} errorMessage="Failed to load startup">
      {(startup) => <StartupShareContent startupId={startup.id} />}
    </QueryGuard>
  )
}
